import { Stack, TableCell, TableRow, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { EnabledChip } from "routes/system-admin/sso-overview/enabled-chip"
import { EstateTokensCell } from "routes/system-admin/sso-overview/estate-tokens-cell"
import { EstateBreakerCell } from "routes/system-admin/sso-overview/estate-breaker-cell"
import { ClientIdpLink } from "routes/system-admin/sso-overview/client-idp-link"

export function EstateClientRow({ item: client }) {
    return (
        <TableRow hover data-cy={`sso-estate-row-${client.clientId}`}>
            <TableCell>
                <Stack spacing={0.25}>
                    <TruncatedTypography variant="subtitle2">{client.clientName}</TruncatedTypography>
                    <Typography variant="caption" color="text.secondary">
                        {client.clientId}
                    </Typography>
                </Stack>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{client.providerName || "—"}</Typography>
                <Typography variant="caption" color="text.secondary">
                    {domainSummary()}
                </Typography>
            </TableCell>
            <TableCell>
                <EnabledChip enabled={client.ssoEnabled} enforced={client.enforceSSO} />
            </TableCell>
            <TableCell>
                <EnabledChip enabled={client.scimEnabled} />
            </TableCell>
            <TableCell>
                <EstateTokensCell tokens={client.tokens} />
            </TableCell>
            <TableCell>
                <EstateBreakerCell breaker={client.breaker} />
            </TableCell>
            <TableCell align="right">
                <Typography variant="body2" color={parkedColour()}>
                    {client.parkedUsers || 0}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <ClientIdpLink clientId={client.clientId} />
            </TableCell>
        </TableRow>
    )

    function parkedColour() {
        return client.parkedUsers ? "warning.main" : "text.secondary"
    }

    function domainSummary() {
        const domains = client.emailDomains ?? []
        if (!domains.length) return "no email domains"
        if (domains.length === 1) return domains[0]
        return `${domains[0]} +${domains.length - 1} more`
    }
}
